export var EXPERIMENT_KEY;
(function (EXPERIMENT_KEY) {
    EXPERIMENT_KEY["SPARKFLOW_QUESTION_FORM_VARIANT"] = "question_form_variant";
    EXPERIMENT_KEY["SPARKFLOW_USE_CASE_BASED_ONBOARDING_VARIANT"] = "use_case_based_onboarding_variant";
})(EXPERIMENT_KEY || (EXPERIMENT_KEY = {}));
export var SPARKFLOW_QUESTION_FORM_VARIANT;
(function (SPARKFLOW_QUESTION_FORM_VARIANT) {
    SPARKFLOW_QUESTION_FORM_VARIANT["DEFAULT"] = "v1";
    SPARKFLOW_QUESTION_FORM_VARIANT["V2"] = "v2";
})(SPARKFLOW_QUESTION_FORM_VARIANT || (SPARKFLOW_QUESTION_FORM_VARIANT = {}));
export var SPARKFLOW_USE_CASE_BASED_ONBOARDING_VARIANT;
(function (SPARKFLOW_USE_CASE_BASED_ONBOARDING_VARIANT) {
    SPARKFLOW_USE_CASE_BASED_ONBOARDING_VARIANT["AGENT_SELECTION"] = "v1";
    SPARKFLOW_USE_CASE_BASED_ONBOARDING_VARIANT["SEARCH"] = "v2";
    SPARKFLOW_USE_CASE_BASED_ONBOARDING_VARIANT["RESEARCH"] = "v3";
})(SPARKFLOW_USE_CASE_BASED_ONBOARDING_VARIANT || (SPARKFLOW_USE_CASE_BASED_ONBOARDING_VARIANT = {}));
//# sourceMappingURL=experiment-variants.const.js.map